<div id="addDoc">
  <div class="row page-header">
    <div class="title-header d-flex align-items-center">
      <div class="add-file"></div>
      {{'Add Additional Document' | translate}}
    </div>
  </div>
  <form [formGroup]="addFileForm">
    <div class="row content">
      <div class="form-group col-md-3">
        <label>{{'Ticket number' | translate}}</label>
        <div class="text-value">{{ documentDetail?.ticket_no }}</div>
      </div>
      <div class="form-group col-md-3">
        <label>{{'Order number' | translate}}</label>
        <div class="text-value">{{ documentDetail?.order_no }}</div>
      </div>
      <div class="form-group col-md-6">
        <label>{{'Cargo #' | translate}}</label>
        <div class="text-value">{{ documentDetail?.container_no }}</div>
      </div>
      <div class="form-group col-md-6">
        <label>{{'Customer / Supplier' | translate}}</label>
        <div class="text-value">{{ documentDetail?.customer?.name }}</div>
      </div>
      <div class="form-group col-md-6">
        <label>{{'Trucking company' | translate}}</label>
        <div class="text-value">{{ documentDetail?.trucking_company?.name }}</div>
      </div>
      <div class="form-group col-md-6">
        <label>{{'Delivery note no.' | translate}}</label>
        <div class="text-value">{{ documentDetail?.delivery_note_no }}</div>
      </div>
      <div class="form-group col-md-6">
        <label>{{'Description of goods' | translate}}</label>
        <div class="text-value">{{ documentDetail?.description }}</div>
      </div>
      <div class="form-group col-md-12">
        <label [class.required]="true">{{'Add additional document' | translate}}</label>
        <app-upload-file
          [drop]="true"
          [classDrop]="'small'"
          fileAccept=".pdf, .doc, .docx, .xls, .xlsx, image/svg, image/jpg, image/jpeg, image/png"
          formControlName="file"
        >
        </app-upload-file>
      </div>
      <div class="form-group col-md-12">
        <label [class.required]="true">{{'Reason for Additional Document' | translate}}</label>
        <textarea
          formControlName="reason"
          class="form-control"
          rows="3"
        ></textarea>
      </div>
      <div class="col-md-12">
        <div class="btn-group text-right">
          <button
            type="button"
            class="btn btn-secondary"
            (click)="onCancel()"
          >{{'Cancel' | translate}}</button>
          <button
            type="button"
            class="btn btn-primary btn-save"
            (click)="onSave()"
            [disabled]="addFileForm.invalid"
          >
            <span *ngIf="!saving">{{'Save' | translate}}</span>
            <div
              *ngIf="saving"
              class="spinner-border"
              role="status"
            ></div>
          </button>
        </div>
      </div>
    </div>
  </form>
</div>
